/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { get } from 'lodash-es';
import { put, select, call, fork } from 'redux-saga/effects';

import { PullRequest } from 'src/components/types';
import {
  pullRequest as pullRequestSchema,
  commit as commitSchema,
} from 'src/redux/pull-request/schemas';
import { getCurrentPullRequestUrlPieces } from 'src/redux/pull-request/selectors';
import { getPullRequestApis } from 'src/sagas/helpers';
import { UrlPieces } from 'src/types/pull-request';

import { LOAD_PULL_REQUEST } from '../actions';
import { fetchSourceRepositoryDetails } from '../actions/fetch-source-repository-details';

export const makeBackbucketSafeNow = () =>
  new Date().toISOString().replace(/Z/, '');

function* fetchSourceRepositoryDetailsSaga(sourceFullName: string) {
  yield put(fetchSourceRepositoryDetails(sourceFullName));
}

function* completePullRequestUpdate(pullRequest: PullRequest) {
  if (pullRequest) {
    const sourceFullName = get(pullRequest, [
      'source',
      'repository',
      'full_name',
    ]);
    const destinationFullName = get(pullRequest, [
      'destination',
      'repository',
      'full_name',
    ]);

    if (sourceFullName && sourceFullName !== destinationFullName) {
      yield fork(fetchSourceRepositoryDetailsSaga, sourceFullName);
    }
  }

  const payload = {
    currentPullRequest: pullRequest,
    defaultMergeStrategy: pullRequest.destination.branch.default_merge_strategy,
    mergeInProgress: pullRequest.merge_in_progress,
    lastPoll: makeBackbucketSafeNow(),
  };

  yield put({
    type: LOAD_PULL_REQUEST.SUCCESS,
    payload,
    meta: {
      schema: {
        currentPullRequest: pullRequestSchema,
        // Once we're 100% on commits api usage this can be removed
        commits: [commitSchema],
      },
    },
  });
}

export function* fetchPullRequest(urlPieces?: UrlPieces) {
  const api = yield* getPullRequestApis();
  // eslint-disable-next-line no-param-reassign
  urlPieces = urlPieces || (yield select(getCurrentPullRequestUrlPieces));

  if (!urlPieces) {
    return;
  }

  const { owner, slug, id } = urlPieces;
  try {
    const pullRequest: PullRequest = yield call(
      api.getLoadPullRequest,
      owner,
      slug,
      id
    );
    yield call(completePullRequestUpdate, pullRequest);
  } catch (e) {
    yield put({ type: LOAD_PULL_REQUEST.ERROR });
  }
}
